import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import FlashNewsListLayer from "../components/FlashNewsListLayer";

const FlashNewsPage = () => {
    return (
        <MasterLayout>
            <FlashNewsListLayer />
        </MasterLayout>
    );
};

export default FlashNewsPage;
